import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {DESTINATION_DATA} from './destination-prop-types';

const SpotListDestinationInfo = ({city, isMonthly, event, destination}) => {
    const hasDestination = !isEmpty(destination);
    // unify destination and city to simplify following code
    const displayDestination = hasDestination
        ? destination
        : {...city, city: city.display_name, title: city.display_name};
    const {
        street_address: address,
        city: displayCity,
        state,
        title,
        monthly_description: monthlyDescription,
        description,
    } = displayDestination;
    const destinationTitle = isMonthly ? `${title} Monthly` : title;
    const destinationDescription =
        isMonthly && monthlyDescription ? monthlyDescription : description;
    const displayTitle = event.title || destinationTitle;
    const displayDescription = event.description || destinationDescription;

    return (
        <div className="SpotListDestinationInfo">
            <h2>{unescape(displayTitle)} Parking Information</h2>
            {event.date && <p>{event.date}</p>}
            <p>
                {address} {displayCity}, {state}
            </p>
            <div dangerouslySetInnerHTML={{__html: displayDescription}} />
        </div>
    );
};

SpotListDestinationInfo.propTypes = {
    city: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    isMonthly: PropTypes.bool.isRequired,
    event: PropTypes.object,
};

SpotListDestinationInfo.defaultProps = {
    event: {},
};

export default SpotListDestinationInfo;
